<template>
  <Row>
    <Col span="24">
      <Form :label-width="80">
        <FormItem label="选择平台">
          <Select class="form-item-clazz" v-model="currentPlat">
            <Option v-for="(it, id) in platList" :key="id" :value="it.platCode" :label="it.platName"></Option>
          </Select>
        </FormItem>
      </Form>
    </Col>
    <Col span="24">
      <Card dis-hover>
        <Row :gutter="5">
          <Col span="12">
            <Card dis-hover>
              <p slot="title">{{currentPlat}}平台角色列表</p>
              <p slot="extra">
                <Button type="primary" size="small" @click="openAddHandle">新增角色</Button>
              </p>
              <b-table
                :columns="columns"
                :loading="tableLoading"
                :data="roleList"
                :open-action="false"
                :highlight-row="true"
                @on-row-click="rowClick"
              ></b-table>
            </Card>
          </Col>
          <Col span="12">
            <Card v-show="!isAdd" dis-hover>
              <p slot="title">修改-{{currentRole.name}}</p>
              <Form :label-width="80" :model="currentRole" :rules="modifyRules" ref="modifyRef">
          <!--      <FormItem label="ID">
                  <Input disabled v-model="currentRole.id"/>
                </FormItem>-->
                <FormItem label="角色名称" prop="name">
                  <Input v-model="currentRole.name"/>
                </FormItem>
                <FormItem label="角色描述">
                  <Input v-model="currentRole.descript"/>
                </FormItem>
                <FormItem label="状态">
                  <i-switch size="large" v-model="currentRole.booleanStatus">
                    <span slot="open">启用</span>
                    <span slot="close">禁用</span>
                  </i-switch>
                </FormItem>
                <FormItem class="form-btn-group">
                  <Button type="primary" @click="openRoleMenu">菜单分配</Button>
                  <Button style="margin-left: 5px;" type="success" :loading="submitLoading" @click="postModifyRoleItem">确认修改</Button>
                </FormItem>
              </Form>
            </Card>
            <Card v-show="isAdd" dis-hover>
              <p slot="title">新增角色</p>
              <Form :label-width="80" :model="addForm" :rules="addRules" ref="addRef">
                <FormItem label="角色名称" prop="name">
                  <Input v-model="addForm.name"/>
                </FormItem>
                <FormItem label="角色描述" prop="descript">
                  <Input v-model="addForm.descript"/>
                </FormItem>
                <FormItem class="form-btn-group">
                  <Button style="margin-left: 5px;" type="success" :loading="submitLoading" @click="addItemHandler">确认</Button>
                </FormItem>
              </Form>
            </Card>
          </Col>
        </Row>
      </Card>
    </Col>
    <RoleMenu ref="roleMenu" :plat-code="currentPlat" :current-role="currentRole"/>
  </Row>
</template>

<script>
  import columnsMixin from './columns'
  import { modifyRules, addRules } from './rules'
  import RoleMenu from './common/RoleMenu'

  export default {
    name: 'RoleManage',
    mixins: [columnsMixin],
    components: { RoleMenu },
    data () {
      return {
        platList: [],
        currentPlat: null,
        roleList: [],
        isAdd: false, // 是否是新增 默认 否
        currentRole: {
          id: null,
          name: null,
          descript: null,
          status: null,
          booleanStatus: false
        },
        modifyRules,
        addForm: {
          name: null,
          descript: null
        },
        addRules
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        this.getPlatList()
      },
      async getPlatList () {
        let { data } = await this.$http.queryCurrentUserPlatInfoList()
        let plat = data.filter(it => it.admin)
        this.platList = plat || []
        plat.length !== 0 && (this.currentPlat = plat[0].platCode)
      },
      async getPlatRoleTree (platCode) {
        this.tableLoading = true
        let { data } = await this.$http.getPlatRoleTree({ platCode })
        this.tableLoading = false
        this.roleList = data
      },
      openAddHandle () {
        this.isAdd = true
        // 切换到新增后重置表单
        this.$nextTick(() => this.$refs['addRef'].resetFields())
        // setTimeout(() => { this.$refs['addRef'].resetFields() }, 50)
      },
      rowClick (row, index) { // 表格单行点击事件
        this.isAdd = false
        row.booleanStatus = row.status === 'Y'
        this.currentRole = row
      },
      async postModifyRoleItem () {
        let validate = await this.$refs['modifyRef'].validate(v => v)
        if (validate) {
          let query = {
            status: this.currentRole.booleanStatus ? 'Y' : 'N',
            platCode: this.currentPlat,
            roleName: this.currentRole.name,
            roleId: this.currentRole.id,
            descript: this.currentRole.descript
          }
          this.submitLoading = true
          let { succ } = await this.$http.updatePlatRole(query)
          this.submitLoading = false
          if (succ) {
            this.getPlatRoleTree(this.currentPlat)
            this.$Message.success('更新角色成功!')
          }
        }
      },
      openRoleMenu () {
        if (!this.currentRole.id) {
          this.$Message.error('请先选择角色')
          return
        }
        this.$refs['roleMenu'].visible = true
      },
      async addItemHandler () {
        let v = await this.$refs['addRef'].validate(v => v)
        if (v) {
          let args = {
            platCode: this.currentPlat,
            roleName: this.addForm.name,
            descript: this.addForm.descript
          }
          this.submitLoading = true
          let { succ } = await this.$http.addRole(args)
          this.submitLoading = false
          if (succ) {
            this.getPlatRoleTree(this.currentPlat)
            this.$Message.success('新增角色成功!')
            this.$refs['addRef'].resetFields()
          }
        }
      }
    },
    watch: {
      currentPlat: {
        handler (c) {
          c && this.getPlatRoleTree(c)
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import "~@/common/style/base.less";

  .checked-row {
    background: #29773d;
  }
</style>
